import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class LoginMetaModel extends FormMetaModel {
    constructor() {
        super('Login', ROUTE_PATH.otp, '', 2);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const email = new SmMetaInputModel(
            'email',
            'email',
            'input',
            true,
            'input-fg form-group col-6 col-md-6',
            1,
            1,
            'Email ID',
            'text',
            '',
            false,
            true,
            true,
            false,
            100,
            5,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            "",
            "",
            false,
            [],
            false,
            "",
            false,
            true,
            false,
            true
        );

        const password = new SmMetaInputModel(
            'password',
            'password',
            'input',
            true,
            'input-fg form-group col-6 col-md-6',
            1,
            1,
            'Password',
            'password',
            '',
            false,
            true,
            true,
            false,
            40,
            4,    
        );

        const login = new SmBtnMetaModel('Submit', 'primary', true, false, true, false);
        

        return {
            email: email,
            password: password,
            login: login,
        };
    }
}